import React, { useState, useEffect } from 'react';
import { getPartnerships, createPartnership } from '../api/api';
import API from '../api/api';

function Partnerships({ onSelect }) {
  const [partnerships, setPartnerships] = useState([]);
  const [showForm, setShowForm] = useState(false);
  const [form, setForm] = useState({ name:'', location:'', cycle_days:'', quota_type:'days' });
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    getPartnerships().then(r => {
      const u = JSON.parse(localStorage.getItem('user')||'null');
      if(u && u.role && u.role !== 'admin' && u.partnership_id) {
        setPartnerships(r.data.filter(p => Number(p.id) === Number(u.partnership_id)));
      } else {
        setPartnerships(r.data);
      }
      setLoading(false);
    });
  }, []);

  const handleSubmit = async (e) => {
    e.preventDefault();
    const res = await createPartnership(form);
    setPartnerships([...partnerships, res.data]);
    setShowForm(false);
    setForm({ name:'', location:'', cycle_days:'', quota_type:'days' });
  };

  const handleDelete = async (id, name) => {
    if (!window.confirm(`هل تريد حذف شراكة "${name}"؟`)) return;
    await API.delete(`/partnerships/${id}/`);
    setPartnerships(partnerships.filter(p => p.id !== id));
  };

  const quotaLabel = { days:'أيام', hours:'ساعات', kilowatts:'كيلوواط' };
  if (loading) return <div style={{ textAlign:'center', padding:'50px' }}>جاري التحميل...</div>;

  return (
    <div style={{ padding:'20px' }}>
      <div style={{ display:'flex', justifyContent:'space-between', alignItems:'center', marginBottom:'20px' }}>
        <h2 style={{ color:'#1e3a5f' }}>الشراكات</h2>
        {(() => { const u = JSON.parse(localStorage.getItem('user')||'null'); return u && u.role === 'admin'; })() && (
          <button onClick={() => setShowForm(!showForm)}
            style={{ padding:'10px 20px', background:'#1e3a5f', color:'white', border:'none', borderRadius:'6px', cursor:'pointer' }}>
            + إضافة شراكة
          </button>
        )}
      </div>

      {showForm && (
        <form onSubmit={handleSubmit} style={{ background:'white', padding:'20px', borderRadius:'10px', marginBottom:'20px', boxShadow:'0 2px 10px rgba(0,0,0,0.1)' }}>
          <h3 style={{ marginBottom:'15px' }}>شراكة جديدة</h3>
          <div style={{ display:'grid', gridTemplateColumns:'1fr 1fr', gap:'15px' }}>
            <div>
              <label style={{ display:'block', marginBottom:'5px', fontWeight:'bold' }}>اسم الشراكة *</label>
              <input value={form.name} onChange={e => setForm({...form, name:e.target.value})} required
                style={{ width:'100%', padding:'8px', border:'1px solid #ddd', borderRadius:'6px', boxSizing:'border-box' }} />
            </div>
            <div>
              <label style={{ display:'block', marginBottom:'5px', fontWeight:'bold' }}>الموقع</label>
              <input value={form.location} onChange={e => setForm({...form, location:e.target.value})}
                style={{ width:'100%', padding:'8px', border:'1px solid #ddd', borderRadius:'6px', boxSizing:'border-box' }} />
            </div>
            <div>
              <label style={{ display:'block', marginBottom:'5px', fontWeight:'bold' }}>أيام الدورة *</label>
              <input type="number" step="0.5" value={form.cycle_days} onChange={e => setForm({...form, cycle_days:e.target.value})} required
                style={{ width:'100%', padding:'8px', border:'1px solid #ddd', borderRadius:'6px', boxSizing:'border-box' }} />
            </div>
            <div>
              <label style={{ display:'block', marginBottom:'5px', fontWeight:'bold' }}>نوع النصاب *</label>
              <select value={form.quota_type} onChange={e => setForm({...form, quota_type:e.target.value})}
                style={{ width:'100%', padding:'8px', border:'1px solid #ddd', borderRadius:'6px', boxSizing:'border-box' }}>
                <option value="days">أيام</option>
                <option value="hours">ساعات</option>
                <option value="kilowatts">كيلوواط</option>
              </select>
            </div>
          </div>
          <div style={{ marginTop:'15px', display:'flex', gap:'10px' }}>
            <button type="submit" style={{ padding:'10px 20px', background:'#27ae60', color:'white', border:'none', borderRadius:'6px', cursor:'pointer' }}>حفظ</button>
            <button type="button" onClick={() => setShowForm(false)} style={{ padding:'10px 20px', background:'#e74c3c', color:'white', border:'none', borderRadius:'6px', cursor:'pointer' }}>إلغاء</button>
          </div>
        </form>
      )}

      <div style={{ display:'grid', gridTemplateColumns:'repeat(auto-fill, minmax(280px, 1fr))', gap:'15px' }}>
        {partnerships.map(p => (
          <div key={p.id} style={{ background:'white', padding:'20px', borderRadius:'10px', boxShadow:'0 2px 10px rgba(0,0,0,0.1)', borderRight:'4px solid #1e3a5f', display:'flex', flexDirection:'column', justifyContent:'space-between', minHeight:'220px' }}>
            <div onClick={() => onSelect(p)} style={{ cursor:'pointer' }}>
              <h3 style={{ color:'#1e3a5f', marginBottom:'8px' }}>💧 {p.name}</h3>
              <p style={{ color:'#666', marginBottom:'5px' }}>📍 {p.location || 'غير محدد'}</p>
              <p style={{ color:'#666', marginBottom:'5px' }}>🔄 دورة {p.cycle_days} يوم</p>
              <p style={{ color:'#666' }}>📊 النصاب: {quotaLabel[p.quota_type]}</p>
              <div style={{ marginTop:'10px', display:'flex', justifyContent:'space-between', alignItems:'center' }}>
                <span style={{ background: p.is_active ? '#d4edda' : '#f8d7da', color: p.is_active ? '#155724' : '#721c24', padding:'3px 10px', borderRadius:'20px', fontSize:'12px' }}>
                  {p.is_active ? 'نشطة' : 'متوقفة'}
                </span>
                <span style={{ color:'#1e3a5f', fontSize:'13px' }}>{p.partners?.length || 0} شريك</span>
              </div>
            </div>
            <div style={{ marginTop:'12px', display:'flex', gap:'8px', borderTop:'1px solid #eee', paddingTop:'12px' }}>
              <button onClick={() => onSelect(p)}
                style={{ flex:1, padding:'8px', background:'#3498db', color:'white', border:'none', borderRadius:'5px', cursor:'pointer', fontSize:'13px', fontWeight:'bold' }}>
                📂 فتح
              </button>
            </div>
          </div>
        ))}
        {partnerships.length === 0 && (
          <div style={{ textAlign:'center', padding:'50px', color:'#666', gridColumn:'1/-1' }}>
            لا توجد شراكات بعد. اضغط "+ إضافة شراكة" للبدء.
          </div>
        )}
      </div>
    </div>
  );
}

export default Partnerships;
